import { useEffect, useState } from "react";
import axios from "axios";
import { getSession } from "../utils/session";
import './FoodHistory.css';
import { API_URL } from "../services/api";

export default function FoodHistory() {
  const [foods, setFoods] = useState([]);
  const [totals, setTotals] = useState({ calories: 0, protein: 0, carbs: 0, fat: 0 });

  useEffect(() => {
    async function fetchFoods() {
      try {
        const { token } = await getSession();
        const res = await axios.get(
          `${API_URL}/foods`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const today = new Date().toDateString();
        const foodsToday = res.data.filter(food =>
          new Date(food.date).toDateString() === today
        );
        setFoods(foodsToday);

        // Calcular totales del día
        let calories = 0, protein = 0, carbs = 0, fat = 0;
        foodsToday.forEach(food => {
          calories += Number(food.calories) || 0;
          protein  += Number(food.protein)  || 0;
          carbs    += Number(food.carbs)    || 0;
          fat      += Number(food.fat)      || 0;
        });
        setTotals({ calories, protein, carbs, fat });
      } catch (err) {
        setFoods([]);
        setTotals({ calories: 0, protein: 0, carbs: 0, fat: 0 });
      }
    }
    fetchFoods();
  }, []);

  return (
    <div className="food-history">
      <h3>Alimentos consumidos hoy</h3>
      <div className="food-totals">
        <span>Calorías: {totals.calories} kcal</span>
        <span>Proteínas: {totals.protein} g</span>
        <span>Carbs: {totals.carbs} g</span>
        <span>Grasas: {totals.fat} g</span>
      </div>
      <div className="food-list">
        {foods.length === 0
          ? <div className="food-empty">No has registrado comidas hoy.</div>
          : foods.map((food, i) => (
            <div className="food-item" key={i}>
              <b>{food.name}</b>
              <span>{food.calories} kcal</span>
              <span>P: {food.protein}g C: {food.carbs}g G: {food.fat}g</span>
              <span className="food-date">
                {new Date(food.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </span>
            </div>
          ))
        }
      </div>
    </div>
  );
}
